<template>
  <div>
    <v-container>
      <v-row v-if="getTempTasks && getTempTasks.length > 0">
        {{ getTempTasks }}
      </v-row>
      <v-row>
        {{ getTempWorklog }}
      </v-row>
      <v-row class="mb-2" no-gutters>
        <button class="btn btn-primary">Aktiviraj</button>
      </v-row>
      <v-row no-gutters>
        <button class="btn btn-primary" @click="addTask">Dodaj Task</button>
        <button class="btn btn-secondary" @click="removeTask">
          Obrisi task
        </button>
      </v-row>
      <div v-for="task in b" :key="task">
        <Task />
      </div>
      <button class="btn btn-primary" @click="submitTasks">Submit tasks</button>
    </v-container>
  </div>
</template>
<script>
import Task from "@/components/Worklog/Task";
import EventBus from "@/eventBus";
export default {
  components: {
    Task
  },
  data() {
    return {
      b: 1
    };
  },
  computed: {
    getTempWorklog() {
      return this.$store.getters.getTempWorklog;
    },
    getAdmins() {
      return this.$store.getters.getAdmins;
    },
    getOptions() {
      return this.$store.getters.getOptions;
    },
    getTempTasks() {
      return this.$store.getters.getTempTasks;
    }
  },
  methods: {
    addTask() {
      this.b++;
      //   EventBus.$emit("NEW_TASK", true);
    },
    removeTask() {
      if (this.b <= 1) return;
      this.b--;
      //EventBus.$emit("NEW_TASK", false);
    },
    submitTasks() {
      EventBus.$emit("NEW_TASK", true);
    }
  }
};
</script>
<style></style>
